import { render, staticRenderFns } from "./DischargeSummary.vue?vue&type=template&id=1976cd8c&scoped=true&"
import script from "./DischargeSummary.vue?vue&type=script&lang=js&"
export * from "./DischargeSummary.vue?vue&type=script&lang=js&"
import style0 from "./DischargeSummary.vue?vue&type=style&index=0&id=1976cd8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976cd8c",
  null
  
)

export default component.exports